export const SAVE = 'itineraryChange.SAVE';
export const VALUE_CHANGED = 'itineraryChange.VALUE_CHANGED';
export const LOAD = 'itineraryChange.VALUE_LOAD';
export const NEXT = 'itineraryChange.NEXT';
export const RESET = 'itineraryChange.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'itineraryChange.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'itineraryChange.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'itineraryChange.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'itineraryChange.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'itineraryChange.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'itineraryChange.RESET_TRAVEL_DELAY_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '18',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.ItineraryChange/constants.js